import { isAxiosError as o } from "axios";
function i(s) {
  var t;
  return o(s) && (s.status === 423 || ((t = s.response) == null ? void 0 : t.status) === 423);
}
export {
  i as default
};
